/** Hosted Pivony MCP server; users add it as a connector in Claude or another MCP client. */
export const MCP_SERVER_URL = "https://mcp.pivony.com/mcp";

export const MCP_SALES_EMAIL = "sales@pivony.com";

/** OAuth authorize parameters the consent page carries to the API. */
export const OAUTH_CONSENT_PARAMS = [
  "response_type",
  "client_id",
  "redirect_uri",
  "scope",
  "state",
  "code_challenge",
  "code_challenge_method",
  "resource",
];

export async function copyTextToClipboard(text) {
  if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
    await navigator.clipboard.writeText(text);
    return true;
  }
  const area = document.createElement("textarea");
  area.value = text;
  area.style.position = "fixed";
  area.style.left = "-9999px";
  document.body.appendChild(area);
  area.select();
  const ok = document.execCommand("copy");
  document.body.removeChild(area);
  return ok;
}
